import { Result, Row, Col, Button } from 'antd';
import { StyledModal } from 'common/components';
import { Typography, Image } from 'antd';
import WalmartLogo from 'assets/retailer/walmart.png';

const { Paragraph, Text } = Typography;

const PostToWalmartSuggestionModal = ({
  visible,
  onCancel,
  productCount,
  togglePostToModal,
}) => {
  const plurality = productCount?.length > 0 ? 's' : '';

  const footer = (
    <Row gutters={[5, 5]}>
      <Col flex='auto'></Col>
      <Col style={{ gap: 5 }}>
        <Button type='default' onClick={onCancel}>
          No, I will post product to Walmart Later
        </Button>
        <Button
          type='primary'
          onClick={() => {
            onCancel();
            togglePostToModal();
          }}
        >
          Yes, I want to post the published product(s) to Walmart now
        </Button>
      </Col>
    </Row>
  );

  return (
    <StyledModal
      visible={visible}
      footer={footer}
      onCancel={onCancel}
      width={700}
      maskClosable={false}
    >
      <Result
        status='success'
        title={
          <Paragraph style={{ marginBottom: 0 }}>
            <Text>You have successfully published the product to GDSN</Text>
          </Paragraph>
        }
        subTitle={
          <Paragraph style={{ marginBottom: 0 }}>
            <Text>
              The published product{plurality} may need to post to Walmart . Do
              you want to continue to post the product{plurality} to
              <Image
                src={WalmartLogo}
                width={100}
                preview={false}
                style={{ marginTop: -2 }}
              />
              ?
            </Text>
          </Paragraph>
        }
      />
    </StyledModal>
  );
};

export default PostToWalmartSuggestionModal;
